import React from 'react';
import AgriaLogo from './svg/AgriaLogo';

export const Logo = () => <AgriaLogo />;
